import React, { useState } from "react";
import AttendanceCodeMappingPanel from "../AttendanceCodeMappingPanel";
import BiometricDevicesIntegrationPanel from "../BiometricDevicesIntegrationPanel";

const SIDEBAR_ITEMS = [
  { key: "codeMapping", label: "Import & export code mapping" },
  { key: "devices", label: "Biometric & API devices" },
];

const ConfigurationStructureTab = ({ darkMode }) => {
  const [activeSection, setActiveSection] = useState("codeMapping");

  return (
    <div className="flex h-full min-h-0 flex-col">
      <h3
        className={`shrink-0 px-4 pt-3 text-base font-semibold sm:px-6 sm:pt-4 sm:text-lg ${
          darkMode ? "text-white" : "text-gray-800"
        }`}
      >
        Codes and devices
      </h3>
      <div className="flex min-h-0 flex-1">
        <aside
          className={`shrink-0 w-56 border-r overflow-y-auto ${
            darkMode ? "border-gray-600 bg-gray-900/40" : "border-gray-200 bg-gray-50"
          }`}
        >
          <nav className="space-y-0.5 p-2">
            {SIDEBAR_ITEMS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setActiveSection(item.key)}
                className={`block w-full text-left px-3 py-2.5 text-sm rounded transition-colors ${
                  activeSection === item.key
                    ? "rh-subnav-active"
                    : darkMode
                    ? "text-gray-300 hover:bg-gray-800"
                    : "text-gray-800 hover:bg-gray-100"
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </aside>
        <div className="min-w-0 flex-1 overflow-y-auto p-6">
          {activeSection === "codeMapping" && (
            <AttendanceCodeMappingPanel darkMode={darkMode} />
          )}
          {activeSection === "devices" && (
            <BiometricDevicesIntegrationPanel darkMode={darkMode} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigurationStructureTab;
